import { IGetOcorrenciaInspecaoPatrimonioByIdUseCase } from "../../../presentation/useCases/read/get_ocorrencia_inspecao_patrimonio_by_id_use_case";
import { OcorrenciaInspecaoPatrimonioModel } from "../../models/ocorrencia_inspecao_patrimonio";
import { IControlePatrimonioRepository } from "../../repositories/ControledePatrimonio";

/**
 * GetOcorrenciaInspecaoPatrimonioByIdUseCase
 */

export class GetOcorrenciaInspecaoPatrimonioByIdUseCase implements IGetOcorrenciaInspecaoPatrimonioByIdUseCase {
  constructor(private readonly repository: IControlePatrimonioRepository) { }

  async getOcorrenciaInspecaoPatrimonioById(idOcorrenciaInspecaoPatrimonio: number): Promise<OcorrenciaInspecaoPatrimonioModel> {
    return await this.repository.getOcorrenciaInspecaoPatrimonioById(idOcorrenciaInspecaoPatrimonio);
  }
}
